// Copyright (c) 2016 Deere & Company

import {
    isNotEmpty,
    isNumberInputValid,
    isRepairDateAfterFailureDate,
    validateClaimUseAmountUnits,
    validateClaimUseAmounts,
    validateUseAmountsIfPinExists
} from '../../shared/services/claim-shared-helper';
import PartsClaim from '@deere/cps-it.warranty-model-factory/lib/claim-part';
import {removeEmptyRows} from '../../shared/services/empty-claim-rows';

export const isPartNormal = claim =>
    !claim.lifeTime && !claim.merchandizeItem;

const isNotNull = value =>
    value !== null;

const hasAtLeastOneClaimItem = claim =>
    claim.parts.length || claim.labor.length || claim.otherCredits.length;

const isRequiredForNormal = (claim, value) =>
    !isPartNormal(claim) || isNotEmpty(value);

const numberIsRequiredForNormal = (claim, value) =>
    claim.lifeTime || isNumberInputValid(value);

const isNotRequiredForLifetime = (claim, value) =>
    claim.lifeTime || isNotEmpty(value);

const hasComplaintCauseCorrection = complaintCauseCorrection => [
    isNotEmpty(complaintCauseCorrection.causeOfComplaining),
    isNotEmpty(complaintCauseCorrection.howWasComplaintCorrected),
    isNotEmpty(complaintCauseCorrection.operatorsComplaint)
].every(rule => rule);

const isRequiredForMerchandise = claim =>
    claim.merchandizeItem ?
        isNumberInputValid(claim.retailInstallDate) :
        true;

const isComplaintCauseCorrectionValid = (claim, complaintCauseCorrection) =>
    claim.lifeTime ?
        true :
        hasComplaintCauseCorrection(complaintCauseCorrection);

export const canShowAllSections = (claimNumber, isValidClaim) =>
    isValidClaim || isNotEmpty(claimNumber);

export const isNormalValid = (claim, allowedUnitsLength) =>
    !isPartNormal(claim) || [
        isNotEmpty(claim.pin) || (isNotEmpty(claim.model) && isNotEmpty(claim.serialNumber)),
        isNotEmpty(claim.previousInvoiceNumber),
        validateUseAmountsIfPinExists(claim, allowedUnitsLength),
        isNotEmpty(claim.referenceInfo.ownershipStatus.key),
        isNumberInputValid(claim.retailInstallDate)
    ].every(rule => rule);

export const isValidClaim = (claim, allowedUnitsLength) => [
    isNotEmpty(claim.failureInfo.failurePartNumber),
    isNotEmpty(claim.responsibleAccount.account),
    isNotEmpty(claim.referenceInfo.referenceNumber1),
    isNormalValid(claim, allowedUnitsLength),
    isRequiredForMerchandise(claim),
    isNotNull(claim.failureInfo.failureDate),
    isNotNull(claim.failureInfo.repairDate),
    isRepairDateAfterFailureDate(claim.failureInfo.repairDate, claim.failureInfo.failureDate)
].every(rule => rule);

export const saveValidate = claim => [
    isValidClaim(claim),
    isNotEmpty(claim.additionalFailureInfo.failureMode.key),
    isNotEmpty(claim.additionalFailureInfo.failureArea),
    isNotEmpty(claim.additionalFailureInfo.downtime.key),
    isComplaintCauseCorrectionValid(claim, claim.complaintCauseCommentsBasis),
    hasAtLeastOneClaimItem(removeEmptyRows(claim, PartsClaim))
].every(rule => rule);

export const mapFormValidation = (property, value, claim) => {

    const boundIsNotRequiredForLifetime = isNotRequiredForLifetime.bind(null, claim);
    const boundIsRequiredForNormal = isRequiredForNormal.bind(null, claim);
    const boundNumberIsRequiredForNormal = numberIsRequiredForNormal.bind(null, claim);

    const map = {
        application: isNotEmpty,
        complaintCause: boundIsNotRequiredForLifetime,
        complaintCorrection: boundIsNotRequiredForLifetime,
        downtime: isNotEmpty,
        failureArea: isNotEmpty,
        failureDate: isNotNull,
        failureMode: isNotEmpty,
        failurePart: isNotEmpty,
        installedBy: isNotEmpty,
        model: isNotEmpty,
        operatorsComplaint: boundIsNotRequiredForLifetime,
        ownershipStatus: boundIsRequiredForNormal,
        partUseAmount: isNotEmpty,
        partUseAmountUnit: isNotEmpty,
        pin: isNotEmpty,
        previousInvoiceNumber: boundIsRequiredForNormal,
        repairDate: isNotNull,
        responsibleAccount: isNotEmpty,
        retailInstallDate: boundNumberIsRequiredForNormal,
        serialNumber: isNotEmpty,
        useAmount: validateClaimUseAmounts,
        useAmountUnit: validateClaimUseAmountUnits,
        workOrderOne: isNotEmpty
    };

    return map[property](value, claim);

};

export const checkClaimValidity = (currentPageValidity, validationFailed, selectedAction) =>
    selectedAction === 'VALIDATE' ?
        !validationFailed && !currentPageValidity :
        false;



// WEBPACK FOOTER //
// ./src/claim/parts/services/claim-validation-helper.js